export default __webpack_public_path__ + "static/media/banner-2.85d3c0ea.png";